import { Minus } from "@phosphor-icons/react";

const Member = ({ isSelected = false, member, onClick, onRemove, key }) => {
  return (
    <div
      key={key}
      className={`flex items-center gap-4 w-full cursor-pointer bg-primary-gray-150 text-black rounded-lg p-3 pb-5 hover:shadow border relative ${
        isSelected ? "border-red-300" : "border-transparent"
      }`}
      onClick={onClick}
    >
      <Minus
        onClick={onRemove}
        className="absolute top-2 right-4 text-primary-red-500"
        size={14}
      />
      <img
        src={
          member?.image?.url ||
          "https://thumbs.dreamstime.com/b/default-avatar-profile-icon-vector-social-media-user-portrait-176256935.jpg"
        }
        className={`h-8 w-8 rounded-full object-cover`}
      />
      <div>
        <h2 className="font-bold">{member?.first_name}</h2>
        <p className="text-sm capitalize text-gray-400">
          {/* {member?.designation?.designation_name ||
            member?.type ||
            member?.userProjects?.type ||
            "Member"} */}
          {member?.goalsCount} Goals
        </p>
      </div>
    </div>
  );
};

export default Member;
